import * as zod from 'zod';
import { differenceInYears, parse, isAfter, isValid } from "date-fns";

export const validationPoltrona = zod.object({
  nome: zod
    .string({ required_error: 'O campo nome não pode ser vazio.' })
    .max(105, { message: 'O campo pode conter no máximo 105 caracteres' })
    .min(1, { message: 'Informe o nome completo com nome e sobrenome' })
    .refine((value) => value.trim().split(/\s+/).length >= 2, {
      message: 'Informe o nome completo com nome e sobrenome',
    }),
  documento: zod
    .string({ required_error: 'O campo documento não pode ser vazio.' })
    .max(20, { message: 'O documento deve ter no máximo 20 caracteres' })
    .min(1, { message: 'Informe o documento' })
    .regex(/^[a-zA-Z0-9]+$/, { message: 'Use apenas letras e números' })
    .refine((value) => value.replace(/\D/g, '').length >= 2, {
      message: 'O documento deve conter pelo menos 2 números',
    }),
  telefone: zod
  .string({ required_error: 'O campo telefone não pode ser vazio.' })
  .max(15, { message: 'O campo pode conter no máximo 15 caracteres' })
  .transform((value) => value.replace(/[_\s]/g, '').trim())
  .refine((value) => {
    const onlyDigits = value.replace(/\D/g, "");
    return onlyDigits.length >= 10;
  }, {
    message: 'O número do telefone parece estar incompleto, favor revisar.'
  }),
  viagem_premiada: zod.boolean(),
  data_nascimento: zod
  .string({ required_error: 'O campo data de nascimento não pode ser vazio.' })
  .max(10, { message: 'O campo pode conter no máximo 10 caracteres' })
  .min(10, { message: 'Informe a data de nascimento **/**/****' })
  .transform((value) => value.replace('_', '').trim())
  .refine((value) => {
    const date = parse(value, "dd/MM/yyyy", new Date());
    return isValid(date) && isAfter(date, new Date("1910-01-01"));
  }, { message: "A data deve ser maior que 01/01/1910" })
  .refine((value) => {
    const date = parse(value, "dd/MM/yyyy", new Date());
    return isValid(date) && differenceInYears(new Date(), date) >= 1;
  }, { message: "O passageiro deve ter pelo menos 1 ano de idade" }),
});


export type formPoltrona = zod.infer<typeof validationPoltrona>;
